import {type ReactNode} from 'react'
import IO from '~/components/IO'

type MarkRuleProps = {
  children: ReactNode
  key: string
}

export const handleBoldMark = ({children, key}: MarkRuleProps) => {
  return (
    <strong className="font-medium" key={key}>
      {children}
    </strong>
  )
}

export const handleCodeMark = ({children, key}: MarkRuleProps) => {
  return (
    <code
      className="rounded border border-solid border-border-subdued bg-surface-default px-s1 font-ibm-plex-mono text-[.85em] leading-120% text-text-primary"
      key={key}
    >
      {children}
    </code>
  )
}

export const handleIOMark = ({key}: MarkRuleProps) => {
  return <IO key={key} />
}

export const handleSuperscriptMark = ({children, key}: MarkRuleProps) => {
  return <sup key={key}>{children}</sup>
}
